// Import dependencies
import * as turf from '@turf/turf';

export const checkDivisionLines = (capacity, geo_data) => {
    console.log("CHECK LINES", capacity, geo_data);
    var land_polygon = capacity.landBase.union_old.geometry;
    var isModified = false;
    var isValid = true;
    var geo_data_modified = {
        features: [],
        type: "FeatureCollection",
    }
    var modified_points = [];
    // Loop th lines
    geo_data.features.forEach((line, line_index) => {
        var points_list = [];
        var coordinates = line.geometry.coordinates;
        var isLineModified = false;
        var coordinates_new = [];
        coordinates.forEach((point_coords, point_index) => {
            var point_isInside = turf.booleanPointInPolygon(turf.point(point_coords), land_polygon);
            var point_coords_new = null;
            // Search closer point if inside, not first or last one
            if (point_isInside && (point_index === 0 || point_index === (coordinates.length - 1))) {
                var close_distance = 100;
                var close_coords = null;
                var alreadyMoved = false;
                // Search middle points of other lines
                for (var i = 0; i < geo_data.features.length; i++) {
                    if (i !== line_index) {
                        for (var j = 0; j < geo_data.features[i].geometry.coordinates.length; j++) {
                            // Verify not other point has moved to it
                            if (modified_points.includes(i + "_" + j)) {
                                break;
                            }
                            // Check if point at same position
                            if (point_coords.join("_") === geo_data.features[i].geometry.coordinates[j].join("_")) {
                                alreadyMoved = true;
                                break;
                            }
                            // If not, calculate distance
                            var distance = turf.distance(turf.point(point_coords), turf.point(geo_data.features[i].geometry.coordinates[j])) * 1000;
                            if (distance < close_distance) {
                                close_distance = distance;
                                close_coords = geo_data.features[i].geometry.coordinates[j];
                            }
                        }
                        if (alreadyMoved === true) {
                            break;
                        }
                    }
                }
                // Search perpendicular points of other lines
                for (var i = 0; i < geo_data.features.length; i++) {
                    if (i !== line_index) {
                        // Calculate closer point on line
                        var nearest = turf.nearestPointOnLine(geo_data.features[i], turf.point(point_coords));
                        var distance = nearest?.properties?.dist ? nearest.properties.dist * 1000 : 100;
                        // Check if point at same position
                        if (distance <= 0) {
                            alreadyMoved = true;
                            break;
                        }
                        if (distance < close_distance) {
                            close_distance = distance;
                            close_coords = nearest.geometry.coordinates;
                        }
                    }
                }
                // Set value if close enought
                if (alreadyMoved === false && close_distance < 0.5) {
                    point_coords_new = close_coords;
                    isModified = true;
                    isLineModified = true;
                }
                else if (alreadyMoved === false) {
                    isValid = false;
                }
            }
            // Stock data
            var point_data = {
                coords: point_coords_new || point_coords,
                isInside: point_isInside,
                isMoved: point_coords_new ? true : false,
            }
            points_list.push(point_data);
            coordinates_new.push(point_coords_new || point_coords);
            // Track modified points
            if (point_coords_new) {
                console.log("Point sticked");
                modified_points.push(line_index + "_" + point_index);
            }
        })
        line.properties.point_list = points_list;
        var line_new = JSON.parse(JSON.stringify(line));
        line_new.geometry.coordinates = coordinates_new;
        geo_data_modified.features.push(line_new);
    });

    var divisionAreas = getDivisionAreas(capacity, geo_data_modified);

    if (geo_data.features.length === 0) {
        isValid = false;
    }

    return { geo_data: geo_data_modified, isModified: isModified, isValid: isValid, divisionAreas: divisionAreas };
}

export const getDivisionAreas = (capacity, geo_data) => {

    if (geo_data.features.length === 0) {
        return null
    }

    // Create multiLineString from division lines
    var mLS = turf.combine(geo_data);
    console.log("mLS", mLS);
    // Create division lines buffer
    var offset = 0.005 / 1000 // 0,5cm in kilometer
    var buffered = turf.buffer(mLS, offset, { steps: 2 });
    console.log("buffered", buffered);
    // Execute slicing
    var land_polygon = capacity.landBase.union_old.geometry;
    var buffer_polygon = buffered.features[0];
    var difference = turf.difference(land_polygon, buffer_polygon);
    console.log("difference", difference);
    // Separate multipolygon into several polygons
    var flatten = turf.flatten(difference);
    console.log("flatten", flatten);
    // Calculate areas
    var flat_features = [];
    for (var i = 0; i < flatten.features.length; i++) {
        var flat_poly = JSON.parse(JSON.stringify(flatten.features[i]));
        var flat_area = turf.area(flat_poly);
        console.log("AREA", flat_area);
        flat_poly.properties.area = flat_area;
        flat_features.push(flat_poly);
    }
    // Sort by area (bigger to smaller)
    flat_features.sort(function (a, b) {
        return b.properties.area - a.properties.area;
    });
    // Add label and other parameters
    flat_features.forEach((flat_poly, flat_poly_index) => {
        flat_poly.properties.label = "D" + (flat_poly_index + 1);
        flat_poly.properties.isTaken = true;
    })
    console.log("flat_features", flat_features);
    // Create division areas (fetaure col of polygons)
    var division_areas = {
        type: "FeatureCollection",
        features: flat_features
    }

    return { lines_buffer: buffered, division_areas: division_areas }
}